import { render, staticRenderFns } from "./addHobr.vue?vue&type=template&id=fc47172c"
import script from "./addHobr.vue?vue&type=script&lang=js"
export * from "./addHobr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports